import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getTv as getTvApi,
  addNewTv as addNewTvApi,
  updateTv as updateTvApi,
  deleteTv as deleteTvApi,
} from "../../helpers/realbackend_helper";

export const getTv = createAsyncThunk("tv/getTv", async (_, { rejectWithValue }) => {
  try {
    const response = await getTvApi();
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addNewTv = createAsyncThunk("tv/addNewTv", async (tv, { rejectWithValue }) => {
  try {
    const response = await addNewTvApi(tv);
    toast.success("Телевизийг амжилттай нэмлээ", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error("Телевиз нэмэхэд алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});

export const updateTv = createAsyncThunk("tv/updateTv", async (tv, { rejectWithValue }) => {
  try {
    const response = await updateTvApi(tv);
    toast.success("Телевизийг амжилттай засварлалаа", { autoClose: 3000 });
    return response;
  } catch (error) {
    toast.error("Телевиз засварлахад алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});

export const deleteTv = createAsyncThunk("tv/deleteTv", async (tv, { rejectWithValue }) => {
  try {
    const response = await deleteTvApi(tv);
    toast.success("Телевизийг амжилттай устгалаа", { autoClose: 3000 });
    return { tv, ...response };
  } catch (error) {
    toast.error("Телевиз устгахад алдаа гарлаа!", { autoClose: 3000 });
    return rejectWithValue(error);
  }
});
